/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllOrg } from './organizationAction';

const initialState = {
    data: {},
    organization: {},
}
const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    extraReducers: {
        [getAllOrg.fulfilled]: (state, { payload }) => {
            state.organizations = payload;
        },
      
        
    }
})

export default organizationSlice.reducer